import { render, staticRenderFns } from "./BannersMobile.vue?vue&type=template&id=ab672fb6&scoped=true"
import script from "./BannersMobile.vue?vue&type=script&lang=js"
export * from "./BannersMobile.vue?vue&type=script&lang=js"
import style0 from "./BannersMobile.vue?vue&type=style&index=0&id=ab672fb6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab672fb6",
  null
  
)

export default component.exports